import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=40bad1f9"
import script from "./rule.vue?vue&type=script&lang=js"
export * from "./rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports